import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  httpUrl = environment.url;
  reportsAvailable = false;
  constructor(private httpClient: HttpClient) {}

  async getReportsData(orgId: any, params: string) {
    return new Promise((resolve, reject) => {
      try {
        this.httpClient
          .get<any>(this.httpUrl + `/getReportData.php?orgId=${orgId}${params}`)
          .subscribe((data) => {
            resolve(data);
          });
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }

  getReportsPermissions(): any {
    return JSON.parse(localStorage.getItem('permissions') || '[]');
  }
}
